// needed by the .countdown section for handling daylight savings GMT offset differences
Date.prototype.stdTimezoneOffset = function() {
	var jan = new Date(this.getFullYear(), 0, 1);
	var jul = new Date(this.getFullYear(), 6, 1);
	return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

Date.prototype.dst = function() {
	return this.getTimezoneOffset() < this.stdTimezoneOffset();
}

// this file initializes all of the plugins that any page might have
$(document).ready(function() {
	
	/**
	 * Secondary navigation behaviors
	 */
	 
	// only target nav elements inside of aside, because this should only target sidebars, and rare cases where there are two navigation elements in the same aside sidebar
    if (typeof $({}).SecondaryNav == 'function' && $('nav', 'aside.sidebar')[0]) {
		$('nav', 'aside').SecondaryNav();
	}
	
	// this is a workaround for when the #jump-links empty <li> needed for directory profiles exists in the nav on some other page that isn't the profile page, it would show an empty <ul> instead of being hidden
	$('ul', 'aside.sidebar nav').each(function() { 
		var ul = $(this);		
		if (ul.find('a').size() === 0) {
			ul.hide();
			ul.addClass('hide-ul');
		}
	});
	
	// Sidebar sticky nav
    if (typeof $({}).StickyNav == 'function' && $('.sidebar')[0]) {
        $('.sidebar').StickyNav(); // if any element inside of .sidebar has a class of .no-sticky, this plugin will be bypassed
    }
	
	/**
	 * Misc. widget/advanced elements init
	 */
	
	// YouTube video element
	if (typeof YoutubeVideo != 'undefined' && $.isFunction(YoutubeVideo)) {
		$('.youtube-video').YoutubeVideo();
	}
	
	// YouTube playlist element
	if ($('.youtube-playlist')[0]) {	
		$('.youtube-playlist').YoutubePlaylist();
	}	
	
	// Elon directory feed
	if (typeof Directory != 'undefined' && $.isFunction(Directory)) {
		$('.directory-feed').Directory();
	}
	
	// Single directory profile page
	if (typeof DirectoryProfile != 'undefined' && $.isFunction(DirectoryProfile)) {
		$('.directory-profile').DirectoryProfile();
	}
	
	// Directory search
	if (typeof DirectorySearch != 'undefined' && $.isFunction(DirectorySearch)) {
		$('.directory-search').DirectorySearch();
	}
	
	// E-Net feeds
	$('.enet-feed').ENet();	
	
	// Tag feeds (Can we get rid of this? - CKS)
	if (typeof TagFeed != 'undefined' && $.isFunction(TagFeed)){
		$('.tag-feed').TagFeed();
	}
	
	// Something else for tag feeds (Again, can we get rid of this? - CKS)
	$('.auto-tab-tags').each(function(i){
		$(this).TagFeedAutoTab({
			widgetNum: i
		});
	});
	
	// Thermometer element
	if (typeof Thermometer != 'undefined' && $.isFunction(Thermometer)) {
		$('.thermometer').Thermometer();
	}	
	
	// Social accounts element
	if ($('.social-accounts')[0]) {
		$('.social-accounts').SocialAccounts(); 
	}
	
	// Countdown element
	$('.countdown').each(function() {
		
		var cur = $(this);

		var settings = {};

		settings.expiryText = cur.attr('data-expirytext');
		settings.alwaysExpire = true;
		settings.expiryUrl = cur.attr('data-expiryurl');

		var timezoneText = cur.attr('data-timezone');
		
		var today = new Date();
		
		if (timezoneText && timezoneText !== '') {
			settings.timezone = parseInt(cur.attr('data-timezone'));
		}

		/*
		@property [format='dHMS'] {string} The format for display - upper case for always, lower case only if non-zero,
		'Y' years, 'O' (letter Oh) months, 'W' weeks, 'D' days, 'H' hours, 'M' minutes, 'S' seconds.
		*/

		settings.format = cur.attr('data-format');
		settings.compact = cur.attr('data-compactstyle').toString().toLowerCase() == 'true';

		var targetText = cur.attr('data-until');
		var targetDate = Date.parse(targetText);
		
		var ESTGMTOffsetHours = 5;
		
		if (today.dst()) {
			ESTGMTOffsetHours = 4;
		}

		var minutesOffsetFromGMT = new Date().getTimezoneOffset() - (60 * ESTGMTOffsetHours);
		
		var MS_PER_MINUTE = 60000;
		var newTargetDate = new Date(targetDate - minutesOffsetFromGMT * MS_PER_MINUTE);

		settings.until = newTargetDate;

		cur.countdown(settings);
	});
	
	/**
	 * Lity caption override & height fix
	 */
	$(document).on('lity:ready', function(event, instance) {
		
		var lityWrapper = $(event.target).parent();
		var lityImg = $(event.target);
		var lityCaption = $(lityImg).attr('alt');
	    
	    var currWindowHeight = $(window).height();
	    var lityImgWidth = $(event.target).width();
	    var lityWrapperMaxHeight = Math.floor(currWindowHeight * 0.8);
	    
	    $(lityImg).css({'max-height': lityWrapperMaxHeight + 'px'});
	    
	    if (lityCaption && lityCaption != 'Image with no description') {
			$(lityWrapper).append('<div class="lity-caption"><p>' + lityCaption + '</p></div>');
	    }
	    
	});
	
	/**
	 * Split UL and OL lists based off of applied class
	 */
	if ($('.list-halves')[0] || $('.list-thirds')[0] || $('.list-fourths')[0]) {
		
		var colClasses = ['list-halves', 'list-thirds', 'list-fourths'];
		var colLists = $('.list-halves, .list-thirds, .list-fourths');
		
		$.each(colLists, function() {
			
			var elClasses = $(this).attr('class');
			var elClassArr = elClasses.split(' ');
			var cleanArr = [];
			
			for (i=0; i < elClassArr.length; i++) {
				if (colClasses.includes(elClassArr[i])) {
					cleanArr.push(elClassArr[i]);
				}
			}
			
			var cleanCount = cleanArr.length;
			var lastIdx = cleanCount - 1;
			
			if (cleanArr[lastIdx] == 'list-halves') {
				$(this).removeClass('list-thirds list-fourths');
			}
			
			if (cleanArr[lastIdx] == 'list-thirds') {
				$(this).removeClass('list-halves list-fourths');
			}	
			
			if (cleanArr[lastIdx] == 'list-fourths') {
				$(this).removeClass('list-halves list-thirds');
			}
			
		});
		
		$('.list-halves').easyListSplitter({ colNumber: 2 });
		$('.list-thirds').easyListSplitter({ colNumber: 3 });
		$('.list-fourths').easyListSplitter({ colNumber: 4 });
		
	}
	
});